export const blockIconsBusinessandpaymentsShowChartNew = (
	<span className='material-symbols-outlined'>show_chart</span>
);
